/**
 * The pixel size a cropped photo is written at.
 *
 * `getCroppedImg` STRETCHES the crop into the output size it is given, and the confirm path handed
 * it a hardcoded 400x400 — so whatever shape the operator cropped was squashed into a square on
 * save. The editor showed one thing and the record kept another, which reads as "it did not save
 * my edit".
 *
 * Two rules: follow the crop's own proportions, and never scale UP. Enlarging a small selection
 * only stores a blurry copy of pixels that were never there.
 */
export function outputSizeFor(
  area: { width: number; height: number },
  maxEdge = 1200,
): { width: number; height: number } | null {
  if (!(area.width > 0) || !(area.height > 0)) return null;

  const longest = Math.max(area.width, area.height);
  const scale = Math.min(1, maxEdge / longest);

  return {
    // An extreme sliver still has to write a real image, never a zero-width canvas.
    width: Math.max(1, Math.round(area.width * scale)),
    height: Math.max(1, Math.round(area.height * scale)),
  };
}
